<div class="loading-spinner" *ngIf="showTable && isLoading">
  <em class="cc-icon cc-icon-spinner" aria-busy="true" aria-live="polite"></em>
</div>

<div *ngIf="showTable && !isLoading" class="wrapper">
  <table aria-describedby="users licenses">
    <thead class="sm-bg-grey-1">
      <tr>
        <th i18n>License Type</th>
        <th i18n>Paid Licenses</th>
        <th i18n>Used Licenses</th>
        <th *ngIf="isSuperAdmin" i18n data-test="rate-header">Rate</th>
      </tr>
    </thead>
    <tbody class="sm-space-y-2">
      <tr>
        <td i18n>Dashpivot Contributors</td>
        <td>
          <input
            [disabled]="!isSuperAdmin"
            [(ngModel)]="model.contributorsLicenses"
            type="number"
            min="0"
            class="billing-input"
            data-test="contributors-licenses-input"
            (input)="onDashpivotContributorsLicenseChange()"
            #contributorsLicensesInput="ngModel"
            [ccPositiveNumberInput]="contributorsLicensesInput"
          />
        </td>
        <td>
          <span class="text-truncate">{{ contributorsUsedLicensesCount }}</span>
        </td>
        <td *ngIf="isSuperAdmin">
          <span class="text-truncate" data-test="contributors-rate">
            {{ dashpivotLicensePlans.includes(model.planType) ? model.contributorsLicensesRate : ratesDefaults.NA }}
          </span>
        </td>
      </tr>
      <tr>
        <td i18n>Dashpivot Visitors</td>
        <td i18n>{{ model.planType !== companyPlanTypes.Standard ? 'Unlimited' : ratesDefaults.NA }}</td>
        <td>
          <span class="text-truncate">{{ visitorsUsedLicensesCount }}</span>
        </td>
        <td *ngIf="isSuperAdmin" i18n data-test="visitors-rate">
          {{ model.planType !== companyPlanTypes.Standard ? ratesDefaults.Free : ratesDefaults.NA }}
        </td>
      </tr>
      <tr>
        <td i18n>Sitemate Paid Users</td>
        <td data-test="sitemate-paid-licenses">
          <div *ngIf="model.planType !== companyPlanTypes.Standard; else notApplicable">
            <input
              [disabled]="!isSuperAdmin"
              [(ngModel)]="model.sitematePaidUsersLicenses"
              type="number"
              min="0"
              class="billing-input"
              data-test="sitemate-paid-licenses-input"
              (input)="onSitematePaidLicenseChange()"
              #sitematePaidLicensesInput="ngModel"
              [ccPositiveNumberInput]="sitematePaidLicensesInput"
            />
          </div>
          <ng-template #notApplicable><span>{{ ratesDefaults.NA }}</span></ng-template>
        </td>
        <td>
          <span class="text-truncate" data-test="sitemate-paid-used">
            {{ model.planType !== companyPlanTypes.Standard ? sitematePaidUsedLicensesCount : ratesDefaults.NA }}
          </span>
        </td>
        <td *ngIf="isSuperAdmin">
          <span class="text-truncate" data-test="sitemate-paid-rate">
            {{ sitematePaidLicensePlans.includes(model.planType) ? model.sitematePaidUsersLicensesRate : ratesDefaults.NA }}
          </span>
        </td>
      </tr>
      <tr>
        <td i18n>Sitemate Free Users</td>
        <td i18n>Unlimited</td>
        <td><span class="text-truncate">-</span></td>
        <td *ngIf="isSuperAdmin" i18n data-test="sitemate-free-rate">{{ ratesDefaults.Free }}</td>
      </tr>
    </tbody>
  </table>
</div>
